export type TechnologySetupKey = {
  id: string
  label: string
  path: string
}

export const TECHNOLOGY_SETUP_MAPPING: TechnologySetupKey[] = [
  { id: 'npm', label: 'Npm', path: 'npm' },
  { id: 'maven', label: 'Apache Maven', path: 'maven' },
  { id: 'nuget', label: '.Net CLI', path: 'nuget' },
  { id: 'pypi', label: 'PyPi', path: 'pypi' },
  { id: 'packagist', label: 'Composer', path: 'packagist' },
  { id: 'ruby', label: 'RubyGems', path: 'rubygems' },
]
